import Raven from 'raven-js';
import { prefixKeys } from 'EmailEditorUI/utils/helpers';
import { capturePageEvent, reportPreviewMetrics
// @ts-expect-error no declarations found for module
} from 'LayoutBuilderUI/actions/ApiActions';
function getNumFailedImages() {
  const failed = new Set();
  for (const img of document.getElementsByTagName('img')) {
    const src = img.getAttribute('src');
    if (src && img.complete && img.naturalHeight === 0 && img.naturalWidth === 0) {
      failed.add(src);
    }
  }
  return failed.size;
}
function navigationTimingObserverCallback(list, dimensions) {
  var _list$getEntriesByTyp;
  const timing = (_list$getEntriesByTyp = list.getEntriesByType('navigation')) === null || _list$getEntriesByTyp === void 0 ? void 0 : _list$getEntriesByTyp[0];
  if (!timing) {
    return;
  }
  const lifecycleTimestamps = window.hsQueuedLifecycleTimestamps;
  const numFailedImages = getNumFailedImages();
  const metrics = [{
    names: Object.assign({}, prefixKeys('ep_lifecycle', lifecycleTimestamps), prefixKeys('navigation', {
      // Derived
      dns: timing.domainLookupEnd - timing.domainLookupStart,
      tls: timing.requestStart - timing.secureConnectionStart,
      tcp: timing.connectEnd - timing.connectStart,
      ttfb: timing.responseStart - timing.requestStart,
      downloadTime: timing.responseEnd - timing.responseStart,
      // Raw
      connectEnd: timing.connectEnd,
      connectStart: timing.connectStart,
      domainLookupEnd: timing.domainLookupEnd,
      domainLookupStart: timing.domainLookupStart,
      domComplete: timing.domComplete,
      domInteractive: timing.domInteractive,
      duration: timing.duration,
      fetchStart: timing.fetchStart,
      redirectCount: timing.redirectCount,
      requestStart: timing.requestStart,
      responseEnd: timing.responseEnd,
      responseStart: timing.responseStart,
      secureConnectionStart: timing.secureConnectionStart,
      startTime: timing.startTime
    })),
    type: 'TIMER'
  }, {
    names: prefixKeys('navigation', {
      numFailedImages,
      transferSize: timing.transferSize
    }),
    type: 'HISTOGRAM'
  }];
  const lastException = Raven.lastException();
  // @ts-expect-error Chromium only
  const responseStatus = `${timing.responseStatus}`;
  const visibilityState = document.visibilityState;
  const extra = Object.assign({
    hasException: !!lastException,
    isEmbedded: window.parent !== window,
    lastExceptionMessage: lastException === null || lastException === void 0 ? void 0 : lastException.message,
    referrer: document.referrer,
    responseStatus,
    visibilityState,
    numFailedImages
  }, Object.fromEntries(metrics.flatMap(({
    names
  }) => Object.entries(names).map(([key, value]) => [key, Math.round(value)]))));
  Raven.captureBreadcrumb({
    data: extra,
    level: 'info',
    message: 'previewNavigationComplete'
  });
  window.LayoutBuilderUI.messenger.onAppReady(() => {
    capturePageEvent('previewNavigationComplete', {
      extra
    });
    reportPreviewMetrics(metrics, Object.assign({}, dimensions, {
      responseStatus,
      visibilityState
    }));
  });
}
export function recordNavigationTimings(dimensions) {
  if (!PerformanceObserver) {
    return;
  }

  // eslint-disable-next-line compat/compat
  new PerformanceObserver((entryList, observer) => {
    try {
      navigationTimingObserverCallback(entryList, dimensions);
    } catch (_unused) {
      // ignore
    } finally {
      observer.disconnect();
    }
  }).observe({
    buffered: true,
    entryTypes: ['navigation']
  });
}